import UNIQUE from '@/common/unique'

export default {
  id: 'break',
  name: 'break',
  type: 'standard',
  moduleName: 'editor_module_break_column',
  hide: true,
  dataSet: {
    mods: 'break',
    column: [
      {
        columnId: '',
        flex: 1,
        height: 1,
        type: 'break'
      }
    ]
  },
  setting: {
    layout: {
      options: []
    },
    action: null,
    detail: null
  }
}
